import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { Uen } from './uen.model';

@Injectable({
  providedIn: 'root'
})
export class UenService {

  listUen:Uen[];

  constructor(private generalHttp:GeneralHttpService) { }

  getUen(){
    return this.generalHttp.getHttp('AdmUens').then(r =>this.listUen = r as Uen[]);
  }

  updateUen(){
    return this.generalHttp.putHttpNotValue('AdmUens')
  }
}
